import React from 'react';
import { RenderModule } from 'holocron';
import { FOR_YOU_MODULE_NAME } from '../../constants/modules';

// todo replace all mock content with persona data in later story
const temporaryArticleProps = {
  title: 'Placeholder title',
  attribution: '',
  imageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/homepage/2026/April/GuestTile1.jpg',
  body: 'Placeholder body',
  ctaLabel: 'CTA label',
  ctaDestination: 'https://www.americanexpress.com/',
};

const ForYou = () => (
  <RenderModule
    moduleName={FOR_YOU_MODULE_NAME}
    props={{
      market: 'us',
      page: 'hp',
      persona: 'mockPersona',
      heading: 'Just For You',
      articles: [
        { id: 'for-you-1', ...temporaryArticleProps },
        { id: 'for-you-2', ...temporaryArticleProps },
        { id: 'for-you-3', placementId: 'TravelWeb_Homepage_ForYou_Tile_3' },
        { id: 'for-you-4', ...temporaryArticleProps },
      ],
    }}
  />
);

export default ForYou;
